import React, { useState, useEffect } from 'react';
import './checkbox.scss';
import {EmailTooltip} from '../../atoms';
import { default as t } from '../../../utils/i18n';
import Checkbox from '@material-ui/core/Checkbox';


export default function CheckBox (props) {
    const displayOptions = props.options;
    const selectedVals = props.list;
    const setSelectedVals = props.setList;
    const selectedItem =  props.selectedItem;
   // const [list, setList] = useState([]); // to Display selected items on top
    const [filteredList, setfilteredList] = useState(props.option); // to display checkbox as per search box
    let [checkedArr, setcheckedArr] = useState([]);
    const [searchItem, setSearchItem] = useState('');
    const [show, showstyle] = useState('');
    if(props.heading.toLowerCase() === 'objective'){
        checkedArr = props.checkedArr
        setcheckedArr = props.setcheckedArr
    }
       

    useEffect(() => {  // list on basis of searched keyword.
        if(filteredList && filteredList.length) {
            // console.log(filteredList);
            setfilteredList(filteredList.sort());
        }
    },[filteredList]) 
    
    
    useEffect(()=> { // default rendering of list on load.
        if(displayOptions.length) {
            setfilteredList(displayOptions.sort());
        }
        // No preference selected by default
      //  console.log(props.heading);
        if(props.heading.toLowerCase() !== 'advertiser' && props.heading.toLowerCase() !== 'objective') {
        const nopref =  document.getElementById(`${props.classname}-nopreference` );
        let checkedItem =  {
            id:  nopref.id,
            value: nopref.name+'-'+nopref.value  
        }
        let checkedList = [];
        checkedList.push(checkedItem);
   
        setSelectedVals(checkedList);
        //  nopref.checked = true;
        setcheckedArr(checkedList.map(e => e.id));
    }
    },[props.options])

    useEffect(() => {
        setcheckedArr(selectedItem);
        filterHandler('');
    },[props.selectedItem])

    useEffect(() => {
        let checkedList = [];
       if(props.isBLSKpi) {
        filteredList.map((item,index) => {
                let checkedItem =  {
                    id: 'Advertiser-'+item.toLowerCase().replaceAll(' ','-'),
                    value: item   
                }
                checkedList.push(checkedItem);
            })
            setSelectedVals(checkedList);
            let newarr = checkedList.map(e=> e.id);
            newarr.push('Advertiser-all');
            setcheckedArr(newarr);
    } else {
        setSelectedVals([]);
        setcheckedArr([]);
    }
    },[props.isBLSKpi])

    const filterHandler  = ((keyword) => {
        //  const keyword = k.trim(); 
        // console.log(`${keyword} : ${displayOptions.filter(item => item.toLowerCase().includes(keyword.toLowerCase()))}`)
            if (!keyword.trim()) {
                showstyle('');  setSearchItem(''); 
                return setfilteredList(displayOptions); 
            } else {
                showstyle('show'); setSearchItem(keyword);
                setfilteredList(displayOptions.filter(item => item.toLowerCase().includes(keyword.toLowerCase())));
            }
         });


     const addAllAdvertisers = (event, advertiserList, list, setList) => {
        let checkedList = [];
        if(event.target.checked) { 
          if(event.currentTarget.name && ((event.currentTarget.name).toLowerCase()) === 'all-advertisers') { // All Advertisers check
            advertiserList.map((item,index) => {
                let checkedItem =  {
                    id: 'Advertiser-'+item.toLowerCase().replaceAll(' ','-'),
                    value: item   
                }
                checkedList.push(checkedItem);
            })
            setList(checkedList);
            let newarr = checkedList.map(e=> e.id);
            newarr.push('Advertiser-all');
            setcheckedArr(newarr);
          } else if (event.currentTarget.name && ((event.currentTarget.name).toLowerCase()) === 'all-objective') { // All Advertisers check
            advertiserList.map((item, index) => {
                let checkedItem = {
                    id: 'Objective-' + item.toLowerCase().replaceAll(' ', '-'),
                    value: item
                }
                checkedList.push(checkedItem);
            })
            setList(checkedList);
            let newarr = checkedList.map(e => e.id);
            newarr.push('Objective-all');
            setcheckedArr(newarr);
         }
        } else {
            setList([]);
            setcheckedArr([]);
        }
       // checkedArr.filter(el => el.id !== `${props.classname}-nopreference`)
     }

    const addItem = (event,list, setList) => {
        let checkedList = [];
       // let  selectors = document.querySelectorAll(`.${props.classname}`)
        if(event.target.checked) {  
            let checkedItem;
            if((event.target.value) === 'no_preference') { // no preference check 
                list = [];
                checkedItem =  {
                    id: event.target.id,
                    value: event.currentTarget.name ? event.currentTarget.name +'-'+event.target.value : event.target.value   
                }
              //  selectors.forEach((el) => el.checked = false)
            } else {
                if(list.length) {
                    let newList = (list.filter(item => (item.value).split('-')[1] !== 'no_preference'));        
                    list = newList;
                }
                checkedItem =  {
                    id: event.target.id,
                    value: event.currentTarget.name ? event.currentTarget.name +'-'+event.target.value : event.target.value   
                } 
                // document.getElementById(event.target.id).checked = true;
                // const nopref = document.getElementById(`${props.classname}-nopreference` );
                // nopref.checked = false;
            } 
               
            checkedList = [...list];
            checkedList.push(checkedItem);
            setList(checkedList);

            setcheckedArr(checkedList.map(e=> e.id));
        }
        else {
            deleteItem(event.target.id, event.target.value, list, setList);
        }
    }
    
    const deleteItem = (id, val, list, setList, classname) => { 
        const templist = [...list];
        // console.log('deleteitem: '+' - '+id +' - '+ val +' - '+ classname);
        // Filter values and leave value which we need to delete
        const updateList = templist.filter(item => item.id !== id);

        //if uncheck all then default no pref should be selected

        if(props.heading.toLowerCase() !== 'advertiser' && props.heading.toLowerCase() !== 'objective' && !updateList.length) {
            const nopref =  document.getElementById(`${props.classname}-nopreference` );
            let checkedItem =  {
                id:  nopref.id,
                value: nopref.name+'-'+nopref.value  
            }
             updateList.push(checkedItem);
          }

        // Update list in state
        setList(updateList);
        setcheckedArr(updateList.map(e=> e.id));

      //  document.getElementById(`${id}`).checked= false;
    }

    
    

    return (   
        <div className="checkbox-wrapper">
            <div className="top-section">
                    <div className="section-header">
                        <h3 className="c-text-heading-3">{props.topHeader}</h3>
                        <div className="tooltip">
                        <EmailTooltip  id={props.classname}  emailToolTip={props.tooltip} />
                        </div>
                    </div>
                <div className="list-scroll">
                <div className="selected-list">
                {selectedVals.map(item => {return(
                    <div className="selected-item" key={item.id}  
                        onClick = { () => deleteItem(item.id, item.value, selectedVals, setSelectedVals, props.classname) } >
                        <span className="selected-value">{(item.value).split('-').length > 0 ? (item.value).split('-')[0]: (item.value) }</span>
                        <span className="cross"><i className='eva eva-close-outline clear-icon'></i></span>
                    </div>
                    )})
                }
                </div>
                </div>
            </div>
            
            <div className="bottom-section">
                <div className="search-field" >
                <i className='eva eva-search-outline search-icon'></i>
                <input type="text" name="search" 
                    placeholder={props.placeholder} 
                    onChange={(e) => filterHandler(e.target.value,e) }  
                    value ={searchItem}
                    autoComplete="off" />
                    <button type="button" className={`clear-btn ${show}`} 
                    onClick={(e) => filterHandler('') }>
                        <i className="eva eva-close-outline clear-icon"></i>
                    </button>
                </div>
                <ul className="checkbox-list"> 
                {/* Fixed options like No preference and All Adervtisers */}
                { (props.heading.toLowerCase() === 'advertiser') ? (
                   <div>
                        {/* <li className="extra-option"> 
                        <Checkbox
                            id={`${props.classname}-nopreference`} 
                            name={t('create.report.option.nopreference')} 
                            value="no_preference" 
                            checked= { checkedArr.includes(`${props.classname}-nopreference`) }
                            onChange={(e) => { addItem(e,selectedVals,setSelectedVals) }}  />
                            <label htmlFor={`${props.classname}-nopreference`}>{t('create.report.option.nopreference')}</label>
                            
                        </li> */}
                        {filteredList && filteredList?.length > 0 &&
                        (<li className="extra-option">
                            <div className="separator">
                                <span>{t('create.report.separator')}</span>
                            </div>
                            <Checkbox 
                                    className={`${props.classname}`} 
                                    id={`${props.heading}-all`}  
                            name="all-advertisers" 
                            checked= { checkedArr.includes(`${props.heading}-all`)}
                            value={t('create.report.option.alladvertisers')}  
                            onChange={(e) => { addAllAdvertisers(e,filteredList,selectedVals,setSelectedVals) }}  /> 
                            <label htmlFor={`${props.heading}-all`}>{t('create.report.option.alladvertisers')}</label>
                            <div className="separator">
                                <span>{t('create.report.separator')}</span>
                            </div>
                        </li>) }
                    </div> )
                    : (props.heading.toLowerCase() === 'objective') ? (
                        <div>
                            {filteredList && filteredList?.length > 0 &&
                                (<li className="extra-option">
                                    {/* <div className="separator">
                                        <span>{t('create.report.separator')}</span>
                                    </div> */}
                                    <Checkbox
                                        className={`${props.classname}`}
                                        id={`${props.heading}-all`}
                                        name="all-objective"
                                        checked={checkedArr.includes(`${props.heading}-all`)}
                                        value={'All objective'}
                                        onChange={(e) => { addAllAdvertisers(e, filteredList, selectedVals, setSelectedVals) }} />
                                    <label htmlFor={`${props.heading}-all`}>{t('all.objective')}</label>
                                    {/* <div className="separator">
                                        <span>{t('create.report.separator')}</span>
                                    </div> */}
                                </li>)}
                        </div>)
                     
                    :
                       ( <li className="extra-option inactive"> 
                                <Checkbox 
                                     id={`${props.classname}-nopreference`} 
                                name={t('create.report.option.nopreference')}
                                value= "no_preference"  
                                checked= { checkedArr.includes(`${props.classname}-nopreference`) }
                                onChange={(e) => { addItem(e, selectedVals,setSelectedVals) }}
                                 />
                                <label htmlFor={`${props.classname}-nopreference`}>{t('create.report.option.nopreference')}</label>
                                <div className="separator">
                                    <span>{t('create.report.separator')}</span>
                                </div>
                            </li>)    
                    
                    }
                    {/* Dynamic list passed via props.options */}
                    { filteredList && filteredList?.length > 0 && filteredList?.map(( item, index) =>  {
                            const names = item?.name ? item?.name : item;
                            const itemName = names?.toLowerCase()?.replaceAll(' ','-');
                        return (
                            <li className="list-options" key={`${props.classname}${index}`} >
                                <Checkbox 
                                    className={`${props.classname} ` } 
                                    id={`${props.heading}-${itemName}`} 
                                    value={item}   
                                    checked= { checkedArr.includes(`${props.heading}-${itemName}`) }
                                    onChange={(e) => { addItem(e,selectedVals,setSelectedVals) }} />
                                <label htmlFor={`${props.heading}-${itemName}`}>{item}</label>
                            </li> 
                            )
                        }
                    ) 
                    }
                </ul> 
            </div>
        </div>
    )
}

